import { getFileName } from "@/Utils/commonExportFunctions";
import type { TimeFilter } from "@/components/v2/DatePicker/constants";
import { EXCEL_FORMAT } from "@/constants/general";
import { translate } from "@/translations/functions/hook";

import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

import { TENANT_CONTAMINATION_COLUMNS } from "./constants";
import type { TenantContaminationRow } from "./types";

type ExportProps = {
  timeframe: TimeFilter;
  rows: TenantContaminationRow[];
};

const generateExcelFile = ({ rows }: ExportProps) => {
  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet(
    translate("portfolioPage:buildingListExportSheetTitle"),
  );

  sheet.columns = TENANT_CONTAMINATION_COLUMNS.map((column) => ({
    header: translate(column.label),
    key: column.key,
    width: 25,
  }));

  sheet.getRow(1).font = {
    bold: true,
  };

  sheet.addRows(
    rows.map((row) => ({
      name: row.name,
      nrLoads: row.nrLoads,
      contaminatedWeight: `${row.contaminatedWeight.toLocaleString()} kg`,
      contaminationRate: `${row.contaminationRate.toLocaleString()} %`,
    })),
  );

  return workbook;
};

export const exportExcel = async (props: ExportProps) => {
  const fileTitle = getFileName(
    "contaminationPage:tenantContaminationExportFileName",
    props.timeframe,
  );
  const workbook = generateExcelFile(props);

  const xls = await workbook.xlsx.writeBuffer();
  saveAs(
    new Blob([xls], {
      type: EXCEL_FORMAT,
    }),
    fileTitle,
  );
};
